import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ButtonClassType, ButtonProps } from './Button/Button';
import {
    IconAddBlack,
    IconAddWhite,
    IconChevronDown,
    IconChevronUp,
    IconDelete,
    IconExportOrange,
    IconExportWhite,
    IconPDF,
    IconSave,
    IconSend,
} from './Icons/Icons';

export const getButtonSaveProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_SAVE" />,
        variant: ButtonClassType.WithoutBorder,
        icon: IconSave,
        ...args,
    };
};

export const getButtonExportProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_EXPORT" />,
        variant: ButtonClassType.Standard,
        icon: IconExportWhite,
        ...args,
    };
};

export const getButtonExportOutlinedProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_EXPORT" />,
        variant: ButtonClassType.ExportOutlined,
        icon: IconExportOrange,
        ...args,
    };
};

export const getButtonImportProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_IMPORT" />,
        variant: ButtonClassType.Standard,
        icon: IconExportWhite,
        ...args,
    };
};

export const getButtonImportOrangeProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_IMPORT" />,
        variant: ButtonClassType.ExportOutlined,
        icon: IconExportOrange,
        ...args,
    };
};

export const getButtonDownloadPdfOutlinedProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="UploadFile_DownloadTitle" />,
        variant: ButtonClassType.DownloadOutlined,
        icon: IconPDF,
        ...args,
    };
};

export const getButtonAddProps = (args?: any): ButtonProps => {
    return {
        variant: ButtonClassType.Standard,
        icon: IconAddWhite,
        ...args,
    };
};

export const getButtonDeleteProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_DELETE" />,
        variant: ButtonClassType.Danger,
        icon: IconDelete,
        ...args,
    };
};

export const getControleQuestionButtonProps = (args?: any): ButtonProps => {
    return {
        icon: IconAddBlack,
        variant: ButtonClassType.DarkOutlined,
        ...args,
    };
};

export const getSendButtonProps = (args?: any): ButtonProps => {
    return {
        icon: IconSend,
        variant: ButtonClassType.Outlined,
        ...args,
    };
};

export const getButtonDeleteDialogProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_DELETE" />,
        variant: ButtonClassType.DeleteDialog,
        ...args,
    };
};

export const getCancelButtonDialogProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_CANCEL" />,
        variant: ButtonClassType.CancelDialog,
        ...args,
    };
};

export const getButtonSaveDialogProps = (args?: any): ButtonProps => {
    return {
        title: <FormattedMessage id="COMMON_SAVE" />,
        variant: ButtonClassType.SaveDialog,
        ...args,
    };
};

export const getTableOrderButtonProps = (isAscending?: boolean, args?: any): ButtonProps => {
    return {
        icon: isAscending ? IconChevronUp : isAscending === false ? IconChevronDown : undefined,
        variant: ButtonClassType.TableOrder,
        iconOnRightSide: true,
        ...args,
    };
};

export const withClassSM = (name: string, isMobile: boolean) => {
    return { className: classNames({ [name]: true, xs: isMobile }) };
};
